// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__fhRT2","circle":"CheckboxInput_circle__tmMF4"};